import { Badge, Spinner, Tooltip } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { usePipeline } from '@/entities/jobs';

type PipelineTasksListProps = {
  pipelineNameOrId: string;
};

export const PipelineTasksList: FC<PipelineTasksListProps> = ({ pipelineNameOrId }) => {
  const { t } = useTranslation(['pipelines']);
  const { data: pipeline, isLoading } = usePipeline(pipelineNameOrId);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-4">
        <Spinner className="size-5" />
      </div>
    );
  }

  if (!pipeline || pipeline.tasks.length === 0) {
    return <div className="p-4 text-muted-foreground">{t('pipelines:noTasks')}</div>;
  }

  const sortedTasks = [...pipeline.tasks].sort((a, b) => a.orderIndex - b.orderIndex);

  return (
    <div className="bg-muted/50 p-4">
      <div className="space-y-2">
        {sortedTasks.map((taskItem) => (
          <Tooltip key={taskItem.orderIndex} tooltip={taskItem.task.id}>
            <div
              className={`flex items-center gap-3 p-2 bg-background rounded-md ${
                !taskItem.isOptional ? '' : 'opacity-60'
              }`}
            >
              <span className="text-foreground text-sm flex-1">
                {taskItem.task.description || t('pipelines:noDescription')}
              </span>
              {taskItem.isOptional && <Badge variant="secondary">{t('pipelines:optional')}</Badge>}
            </div>
          </Tooltip>
        ))}
      </div>
    </div>
  );
};
